import { quranDataUrl, authHeaders } from './utils/http.js';
const __loadedFonts = new Set();
const __loadingFonts = new Set();

async function loadFontPublic(family, relPath) {
  if (__loadedFonts.has(family) || __loadingFonts.has(family)) return;
  __loadingFonts.add(family);
  try {
    const api = quranDataUrl(relPath);
    const res = await fetch(api, { headers: authHeaders(), cache: 'no-store' });
    if (!res.ok) throw new Error('font_api_fetch_failed');
    const buf = await res.arrayBuffer();
    const face = new FontFace(family, buf);
    await face.load();
    document.fonts.add(face);
    __loadedFonts.add(family);
  } catch (_apiErr) {}
  finally { __loadingFonts.delete(family); }
}

export function ensureQcfFont(page, variant) {
  const fam = `p${page}-${variant}`;
  const rel = variant === 'v4'
    ? `fonts/quran/hafs/tajweed_woff2/p${page}.woff2`
    : `fonts/quran/hafs/uthmanic_woff2/p${page}.woff2`;
  try { void loadFontPublic(fam, rel); } catch { }

  if (variant === 'v4') {
    const palId = `palette-${fam}`;
    if (!document.getElementById(palId)){
      const pal = document.createElement('style');
      pal.id = palId;
      pal.textContent = `@font-palette-values --Dark { font-family: '${fam}'; base-palette: 1; }\n@font-palette-values --Light { font-family: '${fam}'; base-palette: 0; }`;
      document.head.appendChild(pal);
    }
  }
  return fam;
}

let indopakLoaded = false;
export function ensureIndopakFont() {
  if (indopakLoaded) return 'indopak';
  try { void loadFontPublic('indopak', 'fonts/quran/hafs/indopak/indopak-nastaleeq-waqf-lazim-v4.2.1.woff2'); } catch { }
  indopakLoaded = true;
  return 'indopak';
}

function addPreload(relPath, family){
  try { void loadFontPublic(family, relPath); } catch { }
}

export function preloadQcfFonts(pages = [], variant = 'v1'){
  const unique = Array.from(new Set(pages || [])).filter(p => Number.isFinite(p));
  for (const page of unique){
    const fam = ensureQcfFont(page, variant);
    const rel = variant === 'v4'
      ? `fonts/quran/hafs/tajweed_woff2/p${page}.woff2`
      : `fonts/quran/hafs/uthmanic_woff2/p${page}.woff2`;
    addPreload(rel, fam);
  }
}

export function ensureSurahNamesFont() {
  try { void loadFontPublic('SurahNames', 'fonts/quran/surah-names/sura_names.woff2'); } catch { }
  return 'SurahNames';
}

export function ensureBasmalaFont() {
  try { void loadFontPublic('QCF_BSML', 'fonts/quran/basmala/QCF_BSML.TTF'); } catch { }
  return 'QCF_BSML';
}
